import React, { useMemo } from 'react';

export function usePromptHint(metaField) {
  const prompt = metaField.attr('prompt');
  const showLabel = !metaField.attr('_hideLabel');
  const richText = metaField.attr('promptHint') === 'richtext';

  const label = useMemo(() => {
    if (!showLabel) {
      return null;
    }
    // eslint-disable-next-line react/no-danger
    return richText ? <div dangerouslySetInnerHTML={{ __html: prompt }} /> : prompt;
  }, [showLabel, richText, prompt]);

  return { label };
}
